
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#patrimoine-culturel_svg__clip0_7935_26449)","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M21.622 35.62L6.78 39.75A8.072 8.072 0 00.865 47.52v15.614h20.757V35.621zM36.613 63.135h5.765V20.47H21.622v42.666h5.765M57.22 39.738l-14.842-4.129v27.515h20.757V47.51a8.072 8.072 0 00-5.916-7.772z","stroke":"#B69E64"}}),_c('path',{attrs:{"d":"M6.354 57.923h9.225c0-4.578-1.638-8.995-4.613-12.466a19.169 19.169 0 00-4.612 12.466zM48.144 57.923h9.225c0-4.578-1.637-8.995-4.612-12.466a19.169 19.169 0 00-4.613 12.466z","stroke":"#1D1D1B"}}),_c('path',{attrs:{"d":"M36.613 63.135V51.5c0-4.578-1.638-8.995-4.613-12.466A19.169 19.169 0 0027.387 51.5v11.635M32 39.023v24.112M32 8.937l6.919 5.766 6.919 5.765H18.162l6.919-5.765L32 8.937z","stroke":"#B69E64"}}),_c('path',{attrs:{"d":"M32 31.85a3.46 3.46 0 100-6.919 3.46 3.46 0 000 6.92z","stroke":"#1D1D1B"}}),_c('path',{attrs:{"d":"M32 8.937V.865M32 8.937V.865M27.964 4.9h8.072M42.378 35.62H21.622","stroke":"#B69E64"}}),_c('path',{attrs:{"d":"M10.967 54.498v-9.052M52.757 54.498v-9.052","stroke":"#1D1D1B"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"patrimoine-culturel_svg__clip0_7935_26449"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h64v64H0z"}})])])])
          )
        }
      }
    